// src/components/ProtectedRoute.js
import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/telemetry';

// Debug flag for route guard logging
const DEBUG_AUTH = false;

const ProtectedRoute = ({ children, requiredRole }) => {
    const { user, isAuthenticated, authReady } = useContext(AuthContext);
    const location = useLocation();

    if (DEBUG_AUTH) {
        console.log('[PROTECTED_ROUTE]', {
            path: location.pathname,
            authReady,
            isAuthenticated,
            requiredRole,
            userRole: user?.role,
        });
    }

    // Don't render children until auth is ready
    if (!authReady) {
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                Establishing session…
            </div>
        );
    }

    if (!isAuthenticated) {
        if (DEBUG_AUTH) {
            console.log('[PROTECTED_ROUTE] redirect -> /login (unauthenticated)', location.pathname);
        }
        // Track auth redirect for drop-off analysis
        trackEvent('auth_redirect', {
            from_path: location.pathname,
            required_role: requiredRole || null,
        });
        // Save current location for post-login redirect (via location state)
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requiredRole && user?.role !== requiredRole) {
        if (DEBUG_AUTH) {
            console.log('[PROTECTED_ROUTE] redirect -> / (role mismatch)', {
                required: requiredRole,
                actual: user?.role,
            });
        }
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute; // Ensure it's exported as default
